import React, {useState, useRef} from "react";
import Layout from "../components/layout";
import { css } from '@emotion/react';
import { graphql } from "gatsby"
import moment from "moment"

import mq from '../components/defaults/styles/mediaquerys';
import { TitleHeader, wrapper, SectionHeading } from "../components/defaults/styles/elements"
import { Grid } from "../components/defaults/assets/svg/mobilenav"
import Tag from "../components/defaults/assets/svg/tag.svg"
import Clock from "../components/defaults/assets/svg/clock.svg"
import GeneralFooter from '../components/general_footer';
import { color } from "../components/defaults/styles/theme"
import AgendaEl from '../components/main/agenda-el';
import SubNav from '../components/main/sub_nav';
import { ChevronRight } from '../components/defaults/assets/svg/pagination';

const seo = {
  frontmatter: {
    title: "Agenda",
  },
}


const nav_data = [
  {
    name: "All Sessions",
    url: "/agenda",
  },
  {
    name: "Breakout Sessions",
    url: "/agenda/tag/breakoutsession"
  },
  {
    name: "Pilot Sessions",
    url: "/agenda/tag/pilot"
  },
  {
    name: "Networking",
    url: "/agenda/tag/networking"
  }
]


const AgendaOverview = () => {
  const [overviewActive, setOverviewActive] = useState(false);
  const [overviewHeight, setOverviewHeight] = useState("2.65em");

  const content = useRef(null)


  const toggleOverview = () => {
    setOverviewActive(overviewActive => !overviewActive)
    setOverviewHeight(
      overviewActive ? "2.65em" : `${content.current.scrollHeight}px`
    )
  }

  const agenda_data = [
    {
      time_start: "13:00",
      time_end: "14:00",
      title: "The Welcome Stream",
      description: "Start the day all together with a live stream",
    },
    {
      time_start: "14:15",
      time_end: "18:00",
      title: "The Main Event: Breakout Sessions + Networking",
      description: "Move through an interactive lineup of Breakout Sessions to exchange on pilot projects and a range of current tech and innovation topics.",
    },
    {
      time_start: "18:00",
      time_end: "19:00",
      title: "The After Hours",
      description: "Wrap up the day together with some virtual networking. Here’s your chance to mingle with other participants, presenters, and organizers.",
    }
  ]
  

  return (
    <div css={css`
      max-width: 35rem;
      margin: .5em 0 3rem;
    `}>
      <SectionHeading
      title="Agenda Overview"
      subtitle="all times CET / Berlin, Germany"
      css={css`
        margin: 0 1em 1em;
      `}
      />
      <div 
        css={css`
          height: ${overviewHeight};
          overflow: hidden;
          transition: height .4s ease-in-out;
          align-items: start;
          margin-top: 2em;
        `}
        ref={content}
      >
        {agenda_data.map((e, index) => (
          <div 
            key={index}
            css={[css`
              margin-bottom: 1.5em;
              margin-left: 1em;
            `]}
          >
            <div css={[css`
              display: flex;
              align-items: flex-start;
              flex-direction: column;
              margin-bottom: .5em;
              ${mq[1]} {
                flex-direction: row;
              }
            `]}>
              <p css={css`
                font-weight: 700;
                white-space: nowrap;
                font-size: .65em;
                display: inline-flex;
                align-items: center;
                color: white;
                background: ${color.main_dark};
                border-radius: 5px;
                padding: .25em .5em;
                margin-right: .75em;
                margin-bottom: .5em;
                ${mq[2]} {
                  margin-bottom: 0;
                }
                svg {
                  height: 1em;
                  width: auto;
                  stroke: white;
                  margin-right: .5em;
                }
              `}><Clock /> {e.time_start} – {e.time_end}</p>
              <p css={css`
                font-weight: 600;
                font-size: .85em;
                margin-bottom: 0;
              `}>{e.title}</p>
            </div>
            <p css={css`
              font-size: .75em;
            `}>{e.description}</p>
          </div>
        ))}
      </div>
      <div 
        css={css`
          display: flex;
          align-items: center;
          background: ${color.accent_light};
          padding: .75em 1em;
          border-radius: 5px;
          margin-top: .1em;
          cursor: pointer;
          outline: none;
          p {
            margin-bottom: 0;
            font-size: .75em;
            font-weight: 500;
            line-height: 1.2em;
          }
          svg {
            height: 1em;
            margin-right: .5em;
            width: auto;
            transform: ${overviewActive ? "rotate(-90deg)" : "none"};
            transition: transform .4s ease-in-out;
          }
        `}
        onClick={toggleOverview}
        onKeyDown={toggleOverview}
        role="button"
        tabIndex={0}
      >
        <ChevronRight />
        <p>Click to {overviewActive ? "hide" : "show"} the agenda overview</p>
      </div>
    </div>
  )
}

const Agenda = ({data, pageContext}) => {
    const {tag} = pageContext;
    //const {date, tag} = pageContext;
    //const dateString = moment(date, "YYYY-MM-DD").format("MMMM Do, YYYY – dddd")

    // const {event_title} = pageContext;


    return (
      <>
        <Layout seo={seo}>
          <TitleHeader
            title={
              `${tag && tag.includes("Session") ? tag + "s" : tag ? tag + " Sessions" : "Expo 9 Agenda"}`
            }
            subtitle={
              "<p>Below you will find our agenda so you will know exactly where to be, and when.</p>"
            }
            icon={tag ? <Tag /> : <Grid />}
          />
          <div css={wrapper}>
            <AgendaOverview />

            <SubNav
              nav_data={nav_data}
              legende={
                `<p>Choose whether you would like to see the entire Expo 9 session list or click on the tag buttons to only display the agenda elements that feature the respective marker.</p>`
              }
            />
          </div>
          
          {/* <Banner
            type="info"
            content='
              <p>
                In order to create your schedule based on the topics you are interested in simply download the respective event invites via <code>Add to calendar</code> and move them to your personal or business calendar.
              </p>
              <p>
                <b>Attention:</b> Some of the sessions might overlap or happen at the same time.
              </p>
            '
            css={css`
              z-index: 1;
              position: relative;
              code {
                font-size: .8em;
                background: rgba(12, 138, 139, 0.3);
                padding: .5em .75em;
                border-radius: 3px;
                white-space: nowrap;
                margin: 0 .5em;
              }
            `}
          /> */}

          <section
            css={css`
              background: ${color.main_light};
              position: relative;
              margin-top: -2.5rem;
              /* &:before {
                content: "";
                position: absolute;
                background: white;
                width: 100%;
                height: 1em;
                top: 0;
                left: 0;
              } */
            `}
          >
            <div
              css={[
                wrapper,
                css`
                  padding-bottom: 5rem;
                  padding-top: 5rem;
                  z-index: 1;
                  position: relative;
                  /* max-width: 60rem; */
                `,
              ]}
            >
              {data.allAirtable.edges.map(({ node }, index) => (
                <AgendaEl
                  key={index}
                  recordId={node.recordId}
                  title={node.data.agenda_title}
                  start={moment(node.data.agenda_start_time).format("HH:mm")}
                  start_utc={moment(node.data.agenda_start_time)
                    .utc()
                    .format("h:mm A")}
                  duration={new Date(node.data.agenda_duration * 1000)
                    .toISOString()
                    .substr(12, 4)}
                  tags={node.data.agenda_tags}
                  speakers={node.data.agenda_speaker}
                  hosts={node.data.agenda_host}
                  teaser={node.data.agenda_teaser}
                  description={
                    node.data.agenda_description
                      ? node.data.agenda_description.childMarkdownRemark.excerpt
                      : ""
                  }
                  limit={node.data.agenda_attendee_limit}
                  registration={node.data.agenda_registration}
                  partners={node.data.agenda_partners}
                  startups={node.data.agenda_startups}
                  rearview={node.data.agenda_rearview}
                  css={css`
                    :not(:last-of-type) {
                      margin-bottom: 1em;
                    }
                  `}
                />
              ))}
            </div>
          </section>
          <GeneralFooter theme={color.main_light} />
        </Layout>
      </>
    )
}

export default Agenda;


export const query = graphql`
         query Agenda($program_id: [String]) {
           allAirtable(
             filter: { 
               table: { eq: "agenda" },
               id: { in: $program_id },
               data: {agenda_publish: {eq: true}}
             }
             sort: { fields: data___agenda_start_time, order: ASC }
           ) {
             edges {
               node {
                 id
                 recordId
                 data {
                   agenda_description {
                     childMarkdownRemark {
                       html
                       excerpt(format: HTML, truncate: true, pruneLength: 512)
                     }
                   }
                   agenda_start_time
                   agenda_tags
                   agenda_title
                   agenda_duration
                   agenda_teaser
                   agenda_registration
                   agenda_attendee_limit
                   agenda_rearview {
                     data {
                       publish
                     }
                   }
                   agenda_partners {
                     recordId
                     data {
                       name
                     }
                   }
                   agenda_startups {
                     recordId
                     data {
                       startup
                     }
                   }
                 }
               }
             }
           }
         }
       `